import React from 'react';

export function Button({
  children,
  variant = 'solid',
  shape = 'rect',
  size = 'md',
  disabled = false,
  onClick,
  type = 'button',
  className = '',
  block = false,
  as: Component = 'button',
  ...rest
}) {
  const classes = [
    'ds-btn',
    `ds-btn--${variant}`,
    shape === 'pill' ? 'ds-btn--pill' : '',
    `ds-btn--${size}`,
    block ? 'ds-btn--block' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  if (Component === 'button') {
    return (
      <button type={type} className={classes} disabled={disabled} onClick={onClick} {...rest}>
        {children}
      </button>
    );
  }

  return (
    <Component className={classes} onClick={onClick} {...rest}>
      {children}
    </Component>
  );
}

export default Button;
